import { render } from "./TheAposAdminBar.vue?vue&type=template&id=be430290&scoped=true"
import script from "./TheAposAdminBar.vue?vue&type=script&lang=js"
export * from "./TheAposAdminBar.vue?vue&type=script&lang=js"

import "./TheAposAdminBar.vue?vue&type=style&index=0&id=be430290&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be430290"],['__file',"admin-bar/ui/apos/components/TheAposAdminBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be430290"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be430290', __exports__)) {
    api.reload('be430290', __exports__)
  }
  
  module.hot.accept("./TheAposAdminBar.vue?vue&type=template&id=be430290&scoped=true", () => {
    api.rerender('be430290', render)
  })

}


export default __exports__